import './index.module.less'
import { Form, Input, Button, Checkbox, Typography } from 'antd'
import { MobileOutlined, LockOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import Router from 'next/router'

import Logo from '../assets/Logo.svg'
import { setUser } from '../lib/sentry'
import { fetcher } from '../lib/hooks'
import analytics from '../lib/analytics'

const TNC_URL =
  'https://leadschool-static.s3.ap-south-1.amazonaws.com/docs/v1/teacher_app'
const { Text } = Typography

export default function LoginPage() {
  const [errorMsg, setErrorMsg] = useState('')
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)
  const [logining, setLogining] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem('auth')) setVisible(true)
  }, [])

  const onFinish = (body) => {
    if (errorMsg) setErrorMsg('')
    const timer = setTimeout(() => setLogining(true), 300)

    fetcher(`/login`, { body, skipAuth: true })
      .then((auth) => {
        localStorage.setItem('auth', JSON.stringify(auth))
        setUser()

        const {
          id,
          name,
          emailid: email,
          mobile,
          su: [su],
        } = auth.user
        analytics.identify(id, {
          name,
          email,
          mobile,
          user_role: su.rolename,
          school_id: su.schoolid,
          school_name: su.schoolname,
        })
        analytics.track('account_logged_in', { success: true })
        // handle no classes assigned scenario

        const noClasses =
          !auth.userAcademicYearIds || auth.userAcademicYearIds === ''

        if (noClasses) Router.replace('/no-classes')
        else if (localStorage.getItem(`onboarded_${id}`))
          Router.replace('/classes')
        else Router.replace('/onboarding')

        clearTimeout(timer)
        setLogining(false)
      })
      .catch((err) => {
        // manually validate tnc field to update ui
        analytics.track('account_logged_in', {
          success: false,
          fail_reason: err.message,
        })

        setErrorMsg(err.message)
        form.validateFields(['tnc'])

        clearTimeout(timer)
        setLogining(false)
      })
  }

  // can be converted into utility fn. for login and forgot-password
  const mobileLengthHandler = ({ target: { value } }) => {
    form.setFieldsValue({
      mobile: value.replace(/\D/g, '').slice(0, 10),
    })
  }

  const passwordLengthHandler = ({ target: { value } }) => {
    if (value.length > 15) {
      form.setFieldsValue({
        password: value.slice(0, 15),
      })
    }
  }

  return (
    <>
      <Form
        name="simple-login"
        className="login-form"
        layout="vertical"
        size="large"
        form={form}
        hideRequiredMark
        onValuesChange={() => {
          if (errorMsg) setErrorMsg('')
        }}
        initialValues={{ tnc: false }}
        onFinish={onFinish}
        style={{ display: visible ? 'block' : 'none' }}
      >
        <div className="lead-logo">
          <Logo />
          <h3>
            <Text>Login with your registered mobile number</Text>
          </h3>
        </div>
        <Form.Item
          name="mobile"
          label="Enter your mobile number"
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              message: 'Enter Mobile Number',
            },
            {
              pattern: /^\d{10}$/,
              message: 'Enter Valid Mobile Number',
              validateTrigger: 'onBlur',
            },
          ]}
        >
          <Input
            prefix={<MobileOutlined className="site-form-item-icon" />}
            placeholder="Mobile"
            onChange={mobileLengthHandler}
          />
        </Form.Item>
        <Form.Item
          name="password"
          label="Enter your password"
          required
          rules={[{ required: true, message: 'Enter password' }]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            onChange={passwordLengthHandler}
          />
        </Form.Item>
        <Form.Item noStyle>
          <Form.Item
            name="tnc"
            valuePropName="checked"
            dependencies={['mobile', 'password']}
            rules={[
              {
                validator: (_, value) =>
                  !value || errorMsg
                    ? Promise.reject(
                        errorMsg || 'Please accept Terms & Conditions',
                      )
                    : Promise.resolve(),
              },
            ]}
          >
            <Checkbox>
              <span>I accept the </span>
              <a href={`${TNC_URL}_tnc.html`} rel="noreferrer" target="_blank">
                Terms & Conditions
              </a>
              <span> and </span>
              <a href={`${TNC_URL}_pp.html`} rel="noreferrer" target="_blank">
                Privacy Policy
              </a>
              .
            </Checkbox>
          </Form.Item>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={logining}
            onClick={() => setErrorMsg('')}
          >
            Login
          </Button>
        </Form.Item>

        <div className="login-form-forgot">
          <a
            href="/forgot-password"
            onClick={() => analytics.track('account_forgot_password')}
          >
            Forgot password? Request OTP?
          </a>
          <div style={{ color: '#969696', marginTop: '15px' }}>
            For best experience use Google Chrome browser
          </div>
        </div>
      </Form>
    </>
  )
}

export function getServerSideProps() {
  return {
    props: {
      title: 'Login',
    },
  }
}
